var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUmbrella = function SvgUmbrella(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "admin-user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.185,
    height: 17.053,
    viewBox: "0 0 19.185 17.053"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "umbrella-solid",
    d: "M8.5,10.049v4.34a.533.533,0,0,1-1.036.177,1.065,1.065,0,0,0-2.009.709,2.724,2.724,0,0,0,2.512,1.779,2.681,2.681,0,0,0,2.695-2.695v-4.34a1.635,1.635,0,0,0-1.066-.453A1.855,1.855,0,0,0,8.5,10.049Zm10.678-.693a9.651,9.651,0,0,0-8.517-7.694v-.6A1.065,1.065,0,0,0,9.592,0,1.091,1.091,0,0,0,8.5,1.066v.6A9.654,9.654,0,0,0,.01,9.356c-.074.306.283.706.622.376C2.364,7.9,4.219,7.987,5.915,10.965a.351.351,0,0,0,.657,0c.673-1.176,1.5-2.438,2.991-2.438,1.948,0,2.937,2.292,3.021,2.438a.351.351,0,0,0,.657,0c1.7-2.982,3.567-3.044,5.283-1.233A.389.389,0,0,0,19.175,9.356Z",
    transform: "translate(0)"
  })));
};
export default SvgUmbrella;